module.exports = __webpack_public_path__ + "img/mobile-19.791d1bc8.png";